module.exports = __webpack_public_path__ + "img/header-mobile-ru.20c37274.jpg";